import React from "react";
import {EMPTY_VALUES, getValueByKey} from "../../../../../Apis/functions";
import RowResumeText from "../../../../../components/RowResumeText";
import GeofenceUserScope from "./GeofenceUserScope";
import {SPEED_UNIT_MODEL} from "../Model/Model";
import {useTranslation} from "react-i18next";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 22 de 01 de 2026
 */

const SummaryDetailsTrafficGeofence = (
    {
        item
    }
) => {
    const speedUnit = getValueByKey(item?.speedUnit, 'name', SPEED_UNIT_MODEL);
    const { t } = useTranslation();

    return (
        <div className={'summary-container input-padding-top'}>
            <div className='row'>
                <div className='col-12 p-0'>
                    <RowResumeText
                        title={t('name')}
                        value={item?.name}
                        tooltip={item?.name}
                        className='mb-4'
                    />
                </div>
                <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6 p-0'>
                    <RowResumeText
                        title={t('speed_unit')}
                        value={speedUnit}
                        className='mb-4'
                    />
                </div>
                <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6 p-0'>
                    <RowResumeText
                        title={t('speed_limit')}
                        value={`${item?.speedLimit} ${speedUnit}`}
                        className='mb-4'
                    />
                </div>
                <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6 p-0'>
                    <RowResumeText
                        title={t('speed_tolerance')}
                        value={`${item?.speedTolerance} ${speedUnit}`}
                        className='mb-4'
                    />
                </div>
                <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6 p-0'>
                    <RowResumeText
                        title={t('description')}
                        value={item?.description}
                        className='mb-4'
                    />
                </div>
                <div className='col-12 p-0 mb-4'>
                    <RowResumeText
                        title={t('user_type')}
                        className='mb-3'
                        value={!item?.applyEmployee && !item?.applyContractor && !item?.applySupplier ?  EMPTY_VALUES.DEFAULT: undefined}
                    />
                    <GeofenceUserScope geofence={item}/>
                </div>
            </div>
        </div>
    )
}

export default SummaryDetailsTrafficGeofence
